import { forwardRef } from 'react'
import styled from 'styled-components'
import {
  space,
  layout,
  typography,
  color,
  flexbox,
  border,
  SpaceProps,
  LayoutProps,
  TypographyProps,
  ColorProps,
  FlexboxProps,
  BorderProps
} from 'styled-system'

import { ThemeWrapper } from '../theme'

type StyledProps = SpaceProps & LayoutProps & TypographyProps & ColorProps & FlexboxProps & BorderProps

export type BoxProps = React.PropsWithChildren<
  Omit<StyledProps & JSX.IntrinsicElements['div'], keyof React.ClassAttributes<any>> & {
    as?: React.ElementType
  } & { block?: boolean }
>

const StyledDiv = styled.div<BoxProps>`
  box-sizing: border-box;
  min-width: 0;

  ${space};
  ${layout};
  ${typography};
  ${color};
  ${flexbox};
  ${border}
`

const InternalBox = (props: BoxProps, ref: any) => (
  <ThemeWrapper>
    {/*! "as" field must be set in this component.
    If it is set in parent component defined in this package, briq-core package or another client package
    then styled-component/styled-system does not work well ! */}
    <StyledDiv {...props} ref={ref} as={props.block === true ? 'div' : props.block === false ? 'span' : undefined} />
  </ThemeWrapper>
)

export const Box = forwardRef(InternalBox)
